import { render } from "./PointDetails.vue?vue&type=template&id=315abd14&scoped=true"
import script from "./PointDetails.vue?vue&type=script&lang=js"
export * from "./PointDetails.vue?vue&type=script&lang=js"

import "./PointDetails.vue?vue&type=style&index=0&id=315abd14&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315abd14"]])

export default __exports__